import React, { useState, useEffect } from "react";
import axios from "axios";
import {
  Box,
  Typography,
  TextField,
  Button,
  MenuItem,
  Grid,
  Card,
  CardContent,
  Paper,
  CircularProgress,
  Container,
  Backdrop,
  Autocomplete,
  Link,
  Checkbox,
  Modal,
  List,
  ListItem,
} from "@mui/material";
import { Formik, Form, Field } from "formik";
import * as Yup from "yup";
import { useDropzone } from "react-dropzone";
import { toast, ToastContainer } from "react-toastify";
import Papa from "papaparse";
import * as XLSX from "xlsx";
import WalletBalanceComponent from "./WalletBalanceComponent";
import { PartnerArrowIcon } from "../../res/NewWebIcons";
import PayoutPopup from "./PayoutPopup";
import PayoutFailedPopup from "./PayoutFailedPopup";
import BulkPayoutSucPop from "./BulkPayoutSucPop";
import BulkPayoutFailed from "./BulkPayoutFailed";
import { useNavigate } from "react-router-dom";
import IpinModal from "../IpaisaMpin/IpinModal";
import SetPasswordModal from "../IpaisaMpin/SetIPMpin"; // Import SetPassword modal
import Swal from "sweetalert2";
import iPaisaLoader from "../Assets/iPaisaLoaderKamran/iPaisaLoaderKamran.gif";

const NewPayout = () => {
  const [walletBalance, setWalletBalance] = useState(0);
  const [showBulkPayout, setShowBulkPayout] = useState(false);
  const bulkPayout = sessionStorage.getItem("bulkPayout") === "true";
  const [showSuccessPop, setShowSuccessPop] = useState(false);
  const [showFailedPop, setShowFailedPop] = useState(false);
  const [bulkPayoutSuccess, setBulkPayoutSuccess] = useState(false);
  const [bulkPayoutFailed, setBulkPayoutFailed] = useState(false);
  const [openSetPasswordModal, setOpenSetPasswordModal] = useState(false); // Controls SetPassword modal
  const [isIpinModalOpen, setIpinModalOpen] = useState(false); // Controls IPIN modal
  const [isLoading, setIsLoading] = useState(false); // State for loader
  const [pendingSubmission, setPendingSubmission] = useState(null); // Store form values to submit after IPIN
  const payoutStatus = sessionStorage.getItem("payoutStatus") === "ACTIVE";
  const formikRef = React.useRef(null);
  const navigate = useNavigate();
  const handleClose = () => {
    setShowSuccessPop(false);
    setShowFailedPop(false);
    setBulkPayoutSuccess(false);
    setBulkPayoutFailed(false);
  };
  const [limits, setLimits] = useState([]);
  const [bankDetails, setBankDetails] = useState([]);
  const [isTCChecked, setIsTCChecked] = useState(false);
  const [openTermsModal, setTermsOpenModal] = useState(false);
  const [tc, setTC] = useState([]);

  const handleCloseTerms = () => {
    setTermsOpenModal(false);
  };

  const handleTCCheckboxChange = (event) => {
    setIsTCChecked(event.target.checked);
  };

  const fetchTC = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.get(
        "https://api.ipaisa.co.in/myapp/auth/getTAndC",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
          params: { serviceType: "payout" },
        }
      );
      console.log(response.data?.body?.data);
      setTC(response.data?.body?.data || []);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  // Fields Validation Condtions
  const PayoutSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    payeeaccountNumber: Yup.string().required(
      "Payee Account Number is required"
    ),
    bankIfsc: Yup.string().required("Bank IFSC is required"),
    transferMode: Yup.string().required("Transfer Mode is required"),

    transferAmount: Yup.number()
      .typeError("Amount must be a valid number")
      .required("Transfer amount is required")
      .positive("Amount must be positive")
      .integer("Amount must be a whole number")
      .test("max-amount", "Amount exceeds the maximum limit", function (value) {
        const { transferMode } = this.parent;
        const selectedLimit = limits.find(
          (limit) => limit.transactionType === transferMode
        );
        const maxAmount = selectedLimit ? selectedLimit.limitAmount : null;

        if (!maxAmount) return true; // If no limit found, skip validation
        return value <= maxAmount;
      }),

    remark: Yup.string().required("Remark is required"),
  });

  const BulkPayoutSchema = Yup.object().shape({
    file: Yup.mixed().required("File is required"),
  });

  const fetchLimits = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.get(
        "https://api.ipaisa.co.in/myapp/auth/get_limit",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setLimits(response.data.body.data || []);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  const fetchWalletBalance = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.get(
        "https://api.ipaisa.co.in/myapp/auth/getwalletbalance",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setWalletBalance(response.data.walletBalance || 0);
    } catch (error) {
      console.error("Error fetching wallet balance:", error);
    }
  };

  const getBankDetails = async () => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const response = await axios.get(
        "https://api.ipaisa.co.in/myapp/auth/getBankDetail",
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      // return response.data.body;
      const bankData = response?.data?.body || [];
      setBankDetails(bankData);
    } catch (error) {
      console.error("Error fetching bank details:", error);
    }
  };

  useEffect(() => {
    fetchWalletBalance();
    getBankDetails();
    fetchLimits();
    fetchTC();
  }, []);

  const handlePayClick = async (values) => {
    setPendingSubmission(values); // Store form values for later submission
    try {
      // Determine which modal to open based on MPIN status
      if (sessionStorage.getItem("isTxnMpinSet") === "False") {
        setOpenSetPasswordModal(true); // Open SetPassword modal if MPIN is not set
      } else {
        setIpinModalOpen(true); // Open IPIN modal if MPIN is set
      }
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to process request");
    }
  };

  // This function is called once the IPIN is validated.
  const handleIpinValid = async (ipin) => {
    setIsLoading(false);
    console.log("Submitted IPIN:", ipin);
    setIpinModalOpen(false);

    // Proceed with payout submission after IPIN validation only if there's a pending submission
    if (pendingSubmission) {
      await handleSubmitAfterIpin(pendingSubmission); // Call the submit function directly

      // Use Formik's resetForm via the reference
      if (formikRef.current) {
        formikRef.current.resetForm(); // Reset the form explicitly
      }
      setPendingSubmission(null); // Clear pending submission after processing
    }
  };

  const handleCloseModal = () => {
    setIpinModalOpen(false);
    setOpenSetPasswordModal(false); // Close SetPassword modal
  };

  const getLocation = async () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position.coords),
          (error) => {
            console.error("Geolocation error:", error);
            // Fallback to default location or handle it gracefully
            resolve({ latitude: 0, longitude: 0 }); // Set a default or allow the API call without location
          }
        );
      } else {
        reject(new Error("Geolocation is not supported by this browser."));
      }
    });
  };

  const handleSubmitAfterIpin = async (values) => {
    setIsLoading(true);

    if (values.transferAmount > walletBalance) {
      Swal.fire({
        icon: "error",
        title: "Insufficient Balance",
        text: "You do not have enough balance for this transaction.",
      });
      setIsLoading(false);
      return;
    }

    try {
      const location = await getLocation();
      const token = sessionStorage.getItem("jwtToken");

      const payload = {
        ...values,
        payeraccountNumber: "120664700000021",
        latitude: location.latitude.toFixed(4),
        longitude: location.longitude.toFixed(4),
      };

      const response = await axios.post(
        "https://api.ipaisa.co.in/myapp/auth/instantpay/payout",
        payload,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (response.status === 200) {
        if (response.data.message === "Success") {
          setShowSuccessPop(true);
          fetchWalletBalance();
        } else if (response.data.message === "Pending") {
          fetchWalletBalance();
          Swal.fire({
            title: "Transaction Processing",
            text: "Your Transaction is under processing.. Please check your updated status in reports",
            icon: "info",
          });
        } else if (response.data.message === "Failed") {
          setShowFailedPop(true);
          fetchWalletBalance();
        } else {
          Swal.fire({
            title: "Transaction onHold..!!",
            text: "Can't Process Your Request.. Please Try Again After Sometime..",
            icon: "question",
            timer: 2000,
          });
        }
      } else if (response.status === 402) {
        Swal.fire({
          icon: "error",
          title: "Insufficient Balance",
          text: "You do not have enough balance for this transaction.",
        });
      } else {
        setShowFailedPop(true);
      }
    } catch (error) {
      console.error("Payout failed:", error);
      Swal.fire({
        title: "Transaction Error",
        text: "An error occurred while processing your payout",
        icon: "error",
      });
      setShowFailedPop(true);
    } finally {
      setIsLoading(false);
    }
  };

  const handleBulkSubmit = async (values, { setSubmitting }) => {
    try {
      const token = sessionStorage.getItem("jwtToken");
      const file = values.file;

      const parsedData = await new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (event) => {
          try {
            const data = event.target.result;
            const workbook = XLSX.read(data, { type: "array" });
            const sheetName = workbook.SheetNames[0];
            const worksheet = workbook.Sheets[sheetName];
            const json = XLSX.utils.sheet_to_json(worksheet);

            const processedRows = json.map((row, index) => {
              if (row.payeeaccountNumber) {
                row.payeeaccountNumber = Number(row.payeeaccountNumber).toFixed(
                  0
                );
              }
              console.log(`Processed Row ${index + 1}:`, row);
              return row;
            });
            resolve(processedRows);
          } catch (e) {
            console.error("Error parsing XLSX:", e);
            reject(e);
          }
        };
        reader.onerror = reject;
        reader.readAsArrayBuffer(file);
      });

      const totalAmount = parsedData.reduce(
        (acc, row) => acc + (Number(row.transferAmount) || 0),
        0
      );

      if (totalAmount > walletBalance) {
        Swal.fire({
          icon: "error",
          title: "Insufficient Balance",
          text: "You do not have enough balance to perform this transaction.",
        });
        setSubmitting(false);
        return;
      }

      // Generate a new XLSX file from the processed data
      const newWorksheet = XLSX.utils.json_to_sheet(parsedData);
      const newWorkbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(newWorkbook, newWorksheet, "Sheet1");
      const newXlsxData = XLSX.write(newWorkbook, {
        bookType: "xlsx",
        type: "array",
      });
      const newXlsxFile = new Blob([newXlsxData], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      // Create FormData and append the generated XLSX file
      const formData = new FormData();
      formData.append("file", newXlsxFile, "processed_payout.xlsx");
      formData.append("name", "CASHFREE");

      // Submit the FormData with the generated CSV file to the API
      const response = await fetch(
        "https://api.ipaisa.co.in/myapp/auth/launchjob",
        {
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: formData,
        }
      );

      const result = await response.json();
      // console.log("Bulk Payout API Response:", result);

      if (response.ok && result.status === "200") {
        Swal.fire({
          icon: "success",
          title: "Bulk Payout Successful",
          text: result.message || "Bulk Payout successful",
        });
        fetchWalletBalance();
        // setBulkPayoutSuccess(true);
      } else {
        const errorMessage = result.message || "Failed to submit bulk payout";
        Swal.fire({
          icon: "error",
          title: "Bulk Payout Failed",
          text: errorMessage,
        });
      }
    } catch (error) {
      console.error("Bulk Payout failed:", error);
      Swal.fire({
        icon: "error",
        title: "Bulk Payout Failed",
        text: "An error occurred. Please try again later.",
      });
    } finally {
      // Ensure form submission state is reset
      setSubmitting(false);
    }
  };

  const inputHeight = "56px";

  const BulkFileUpload = ({ setFieldValue }) => {
    const [selectedFile, setSelectedFile] = useState(null);
    const [error, setError] = useState("");

    const { getRootProps, getInputProps } = useDropzone({
      accept: ".xlsx, .xls",
      onDrop: (acceptedFiles, rejectedFiles) => {
        if (acceptedFiles.length > 0) {
          setFieldValue("file", acceptedFiles[0]);
          setSelectedFile(acceptedFiles[0]);
          setError("");
        } else if (rejectedFiles.length > 0) {
          setError("Only .xlsx and .xls files are allowed");
        }
      },
    });

    const handleRemoveFile = () => {
      setFieldValue("file", null);
      setSelectedFile(null);
      setError("");
    };

    console.log("bankDetails", bankDetails);
    return (
      <div>
        <div
          {...getRootProps()}
          style={{
            border: "2px dashed #CCCCCC",
            padding: "20px",
            textAlign: "center",
            cursor: "pointer",
            marginBottom: "16px",
          }}
        >
          <input {...getInputProps()} />
          <Typography>
            Drag and Drop a XLSX file here or click to select a file
          </Typography>
        </div>
        {error && (
          <Typography color="error" variant="body2">
            {error}
          </Typography>
        )}
        {selectedFile && (
          <Box
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              mt: 2,
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                width: "100%",
              }}
            >
              <Typography>{selectedFile.name}</Typography>
              <Button
                variant="outlined"
                color="error"
                onClick={handleRemoveFile}
              >
                Remove
              </Button>
            </Box>
          </Box>
        )}
        <Typography sx={{ mt: 1 }}>
          <a
            href="/data.xlsx"
            download="sample.xlsx"
            style={{ textDecoration: "none", color: "#007bff" }}
          >
            Sample XLSX file
          </a>
        </Typography>
      </div>
    );
  };
  console.log(bankDetails);

  return (
    <Box style={{ padding: "2rem", marginTop: "calc(3% + 56px)" }}>
      {/* Loader backdrop */}
      <ToastContainer />
      <Backdrop
        sx={{
          color: "#fff",
          zIndex: (theme) => theme.zIndex.drawer + 1,
          display: "flex",
          flexDirection: "column", // GIF aur text ko column-wise align karne ke liye
          alignItems: "center",
          justifyContent: "center",
        }}
        open={isLoading}
      >
        <img src={iPaisaLoader} alt="Loading..." />
        <Typography sx={{ marginTop: "1%", fontSize: "16px" }}>
          Processing...
        </Typography>
      </Backdrop>
      <Grid>
        <Grid
          style={{
            display: "flex",
            alignItems: "center",
            gap: "1%",
            justifyContent: "start",
          }}
        >
          <Typography
            color="textSecondary"
            style={{ fontFamily: "sans-serif", fontSize: "13px" }}
          >
            Balance
          </Typography>
          <PartnerArrowIcon />
          <Typography
            color="textSecondary"
            style={{ fontFamily: "sans-serif", fontSize: "13px" }}
          >
            Pay Out
          </Typography>
        </Grid>

        <Grid
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            marginTop: "1%",
          }}
        >
          <Grid>
            <Typography
              style={{
                fontWeight: "bold",
                fontFamily: "sans-serif",
                fontSize: "20px",
                color: "#343C6A",
              }}
            >
              Pay Out
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Grid container spacing={2} style={{ marginTop: "3%" }}>
        {/* Wallet Balance Card */}
        <WalletBalanceComponent walletBalance={walletBalance} />

        <Grid item xs={12} md={8} order={{ xs: 2, md: 1 }}>
          <Paper
            style={{
              boxShadow: "none",
              padding: "2rem",
              borderRadius: "8px",
              boxShadow: "none",
            }}
          >
            <Box
              sx={{ display: "flex", justifyContent: "space-evenly", mb: 2 }}
            >
              <Button
                onClick={() => setShowBulkPayout(false)}
                style={{
                  borderBottom: showBulkPayout ? "none" : "2px solid #027BFE",
                  textTransform: "none",
                  color: showBulkPayout ? "#808080" : "#027BFE",
                  marginRight: "10px",
                  fontSize: "16px",
                }}
              >
                Payout
              </Button>
              {bulkPayout && (
                <Button
                  onClick={() => setShowBulkPayout(true)}
                  style={{
                    borderBottom: showBulkPayout ? "2px solid #027BFE" : "none",
                    textTransform: "none",
                    color: showBulkPayout ? "#027BFE" : "#808080",
                    fontSize: "16px",
                  }}
                >
                  Bulk Payout
                </Button>
              )}
            </Box>

            {bulkPayout && showBulkPayout ? (
              <Formik
                initialValues={{ file: null }}
                validationSchema={BulkPayoutSchema}
                onSubmit={handleBulkSubmit}
              >
                {({
                  isSubmitting,
                  setFieldValue,
                  errors,
                  touched,
                  isValid,
                  resetForm,
                }) => (
                  <Form>
                    <BulkFileUpload setFieldValue={setFieldValue} />
                    {errors.file && touched.file ? (
                      <div style={{ color: "red" }}>{errors.file}</div>
                    ) : null}
                    <Box
                      display="flex"
                      justifyContent="end"
                      gap={1}
                      sx={{ flexDirection: { xs: "column", md: "row" } }}
                    >
                      <Button
                        sx={{
                          border: "1.5px solid #FF0000",
                          color: "#FF0000",
                          textTransform: "none",
                          width: { xs: "100%", md: "18%" },
                          fontSize: "16px",
                          borderRadius: "8px",
                          height: inputHeight,
                        }}
                      >
                        Cancel
                      </Button>
                      {payoutStatus && (
                        <Button
                          type="submit"
                          sx={{
                            backgroundColor: "#027BFE",
                            color: "white",
                            textTransform: "none",
                            width: { xs: "100%", md: "18%" },
                            fontSize: "16px",
                            borderRadius: "8px",
                            height: inputHeight,
                            "&:hover": {
                              backgroundColor: "#027BFE",
                              color: "#FFFFFF",
                            },
                          }}
                          disabled={isSubmitting}
                        >
                          {isSubmitting ? (
                            <CircularProgress
                              size={24}
                              style={{ color: "white" }}
                            />
                          ) : (
                            "Bulk Payout"
                          )}
                        </Button>
                      )}
                    </Box>
                  </Form>
                )}
              </Formik>
            ) : (
              <Formik
                initialValues={{
                  name: "",
                  payeeaccountNumber: "",
                  bankIfsc: "",
                  transferMode: "",
                  transferAmount: "",
                  remark: "",
                  purpose: "REIMBURSEMENT",
                }}
                validationSchema={PayoutSchema}
                onSubmit={handlePayClick}
                innerRef={formikRef} // Attach the ref to Formik
              >
                {({
                  isSubmitting,
                  errors,
                  touched,
                  setFieldValue,
                  values,
                  isValid,
                  resetForm,
                }) => (
                  <Form>
                    <Grid container spacing={2}>
                      <Grid item xs={12} md={6}>
                        <Field
                          as={TextField}
                          name="name"
                          label="Name"
                          variant="outlined"
                          fullWidth
                          disabled
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        {bankDetails?.length > 0 ? (
                          <Autocomplete
                            options={bankDetails}
                            getOptionLabel={(option) => {
                              // Ensure both accountNumber and name exist and are not undefined
                              return `${option.accountNumber || "No Account Number"} - ${option.name || "No Name"}`;
                            }}
                            isOptionEqualToValue={(option, value) =>
                              option.accountNumber === value.accountNumber
                            } // Compare with accountNumber
                            onChange={(event, selectedOption) => {
                              if (selectedOption) {
                                // Update your state or form values directly here
                                setFieldValue(
                                  "payeeaccountNumber",
                                  selectedOption.accountNumber
                                );
                                setFieldValue("bankIfsc", selectedOption.ifsc);
                                setFieldValue("name", selectedOption.name);
                                setFieldValue(
                                  "bankName",
                                  selectedOption.bankName
                                );
                                // Add any other fields you want to auto-fill here
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Account Number"
                                fullWidth
                                variant="outlined"
                                error={Boolean(
                                  errors.payeeaccountNumber &&
                                    touched.payeeaccountNumber
                                )}
                                helperText={
                                  touched.payeeaccountNumber &&
                                  errors.payeeaccountNumber
                                }
                              />
                            )}
                          />
                        ) : (
                          <Typography
                            variant="body1"
                            color="error"
                            style={{ marginTop: "16px" }}
                          >
                            No bank details added
                          </Typography>
                        )}
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Field
                          as={TextField}
                          name="bankIfsc"
                          label="Bank IFSC"
                          variant="outlined"
                          fullWidth
                        />
                      </Grid>
                      <Grid item xs={12} md={6}>
                        <Field
                          as={TextField}
                          name="transferMode"
                          label="Transfer Mode"
                          select
                          variant="outlined"
                          fullWidth
                          onChange={(e) =>
                            setFieldValue("transferMode", e.target.value)
                          }
                        >
                          {limits.map((limit) => (
                            <MenuItem
                              key={limit.transactionType}
                              value={limit.transactionType}
                            >
                              {limit.transactionType}
                            </MenuItem>
                          ))}
                        </Field>
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Field
                          as={TextField}
                          name="transferAmount"
                          label="Transfer Amount"
                          variant="outlined"
                          type="number"
                          fullWidth
                          onChange={(e) => {
                            let value =
                              e.target.value.trim() === ""
                                ? ""
                                : Number(e.target.value);
                            setFieldValue("transferAmount", value);
                          }}
                          value={
                            values.transferAmount === 0
                              ? ""
                              : values.transferAmount
                          }
                          error={Boolean(
                            errors.transferAmount && touched.transferAmount
                          )}
                          helperText={
                            touched.transferAmount && errors.transferAmount
                              ? values.transferMode
                                ? `${errors.transferAmount} (Max: ₹${
                                    limits
                                      .find(
                                        (limit) =>
                                          limit.transactionType ===
                                          values.transferMode
                                      )
                                      ?.limitAmount?.toLocaleString() || 0
                                  })`
                                : errors.transferAmount
                              : ""
                          }
                        />
                      </Grid>

                      <Grid item xs={12} md={6}>
                        <Field
                          as={TextField}
                          name="remark"
                          label="Remarks"
                          variant="outlined"
                          fullWidth
                        />
                      </Grid>
                    </Grid>
                    <Grid item xs={12}>
                      <Box
                        display="flex"
                        flexDirection="column"
                        alignItems="start"
                      >
                        {/* Terms and Conditions Checkbox */}
                        <Box display="flex" alignItems="center">
                          <Checkbox
                            checked={isTCChecked}
                            onChange={handleTCCheckboxChange}
                            color="primary"
                          />
                          <Typography variant="body2">
                            I accept the&nbsp;
                            <Link
                              component="button"
                              type="button"
                              onClick={(event) => {
                                event.stopPropagation(); // Prevent any unwanted bubbling
                                setTermsOpenModal(true); // Ensure only the terms modal opens
                              }}
                              style={{
                                color: "#027BFE",
                                textDecoration: "underline",
                              }}
                            >
                              Terms and Conditions
                            </Link>
                          </Typography>
                        </Box>
                      </Box>
                      <Box
                        display="flex"
                        justifyContent="end"
                        gap={1}
                        sx={{ flexDirection: { xs: "column", md: "row" } }}
                      >
                        <Button
                          sx={{
                            border: "1.5px solid #FF0000",
                            color: "#FF0000",
                            textTransform: "none",
                            width: { xs: "100%", md: "18%" },
                            fontSize: "16px",
                            borderRadius: "8px",
                            height: inputHeight,
                          }}
                          onClick={() => resetForm()} // Reset form on cancel
                          disabled={isSubmitting} // Disable if form is invalid or submitting
                        >
                          Cancel
                        </Button>
                        <Button
                          type="submit"
                          sx={{
                            backgroundColor: "#027BFE",
                            color: "white",
                            textTransform: "none",
                            width: { xs: "100%", md: "18%" },
                            fontSize: "16px",
                            borderRadius: "8px",
                            height: inputHeight,
                            "&:hover": {
                              backgroundColor: "#027BFE",
                              color: "#FFFFFF",
                            },
                          }}
                          disabled={
                            !isTCChecked ||
                            !isValid ||
                            isSubmitting ||
                            (values.transferMode &&
                              values.transferAmount >
                                (limits.find(
                                  (limit) =>
                                    limit.transactionType ===
                                    values.transferMode
                                )?.limitAmount || 0))
                          }
                        >
                          Pay
                        </Button>
                      </Box>
                    </Grid>
                  </Form>
                )}
              </Formik>
            )}
          </Paper>
        </Grid>
      </Grid>
      {showSuccessPop && <PayoutPopup handleClose={handleClose} />}
      {showFailedPop && <PayoutFailedPopup handleClose={handleClose} />}
      {bulkPayoutSuccess && <BulkPayoutSucPop handleClose={handleClose} />}
      {bulkPayoutFailed && <BulkPayoutFailed handleClose={handleClose} />}

      {/* Terms and Conditions Modal */}
      <Modal
        open={openTermsModal}
        onClose={handleCloseTerms}
        aria-labelledby="terms-modal-title"
      >
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            width: 400,
            bgcolor: "white",
            boxShadow: 24,
            p: 4,
            borderRadius: "8px",
          }}
        >
          <Typography id="terms-modal-title" variant="h6">
            Terms and Conditions
          </Typography>
          {tc.length > 0 ? (
            <List>
              {tc.map((term, index) => (
                <ListItem key={term.id}>
                  <Typography variant="body2">
                    🔹 {term.termsAndConditions}
                  </Typography>
                </ListItem>
              ))}
            </List>
          ) : (
            <Typography variant="body2">
              Currently, there are no terms and conditions available.
            </Typography>
          )}
          <Button
            onClick={handleCloseTerms}
            sx={{
              mt: 2,
              backgroundColor: "#027BFE",
              color: "white",
              textTransform: "none",
            }}
          >
            Close
          </Button>
        </Box>
      </Modal>

      {sessionStorage.getItem("isTxnMpinSet") === "False" ? (
        <SetPasswordModal
          open={openSetPasswordModal}
          onClose={() => setOpenSetPasswordModal(false)}
          onMpinValid={handleIpinValid}
        />
      ) : (
        <IpinModal
          open={isIpinModalOpen}
          onClose={handleCloseModal}
          onMpinValid={handleIpinValid}
        />
      )}
    </Box>
  );
};

export default NewPayout;
